<template>
  <div class="suppliers">

    <div class="title-button">

      <h1>Suppliers</h1>

      <router-link to="/suppliers/create" class="button p-3" v-if="userRole == 1">New supplier</router-link>

    </div>

    <div class="box">

      <form @submit.stop.prevent="doSearch" class="box__header form--inline">
        <input v-model="quickSearch" type="search" placeholder="Quick search">
        <button class="button button--small" type="submit">Search</button>
      </form>

      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="options"
        @edit="doEdit"
        >
      </vdtnet-table>

    </div><!-- box -->

  </div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'

export default {
  name: 'suppliers',
  components: {
    VdtnetTable
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data() {
    return {
      options: {
        ajax: {
          url: this.$api + 'suppliers/table',
          headers: {
            'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500, -1], [25, 50, 100, 500, 'All'] ],
        pageLength: 25,
      },
      fields: {
        supplier_name: { label: 'Name'},
        actions: {
          sortable: false,
          label: ' ',
          render: (data, type, row) => {
            return `<a href="/supplier/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
          }
        }
      },
      quickSearch: ''
    }
  },
  methods: {
    doSearch() {
      this.$refs.table.search(this.quickSearch)
    },
    doEdit(data) {
      this.$router.push({ name: 'supplier-edit', params: { id: data.id }})
    },
  }
}

</script>
